/**
 * Returns a function that will remove all characters matched in the string provided.
 *
 * Example usage:
 * const strippingFunction = strip-characters('-,;');
 * const strippedString = strippingFunction('9191-0101-88,1');
 *
 * @param charactersToStrip: string
 * @param caseSensitive: boolean
 * @returns {function(string): string}
 */

export default function (charactersToStrip, caseSensitive = true) {
  return (string) => {
    if (!string) return;
    const flags = `g${caseSensitive ? '' : 'i'}`;
    const replacementRegex = new RegExp(`[${charactersToStrip}]`, flags);
    return string.replace(replacementRegex, '');
  };
}
